import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Typography } from '@material-ui/core'
import ContentWrapper from '../ContentWrapper';
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    justifyContent: 'center',
    height: '100%',
    padding: '40px 24px 0',
    backgroundColor: '#f0f0f7',
    '& > *': {
      height: theme.spacing(16),
      width: '100%',
      padding: theme.spacing(2),
      maxWidth: '784px',
      '@media(max-width: 1050px)': {
        height: 'unset'
      }
    },
    '@media(max-width: 1050px)': {
      width: 'unset',
      height: 'unset'
    }
  },
  title: {
    color: '#cb4982',
    width: '100%',
    borderBottom: '1px solid #cb4982',
    marginBottom: '16px'
  },
}));
const NoContent = ({ open }) => {
  const classes = useStyles();
  return (
    <ContentWrapper open={open}>
      <div className={classes.root}>
        <Paper >
          <Typography gutterBottom variant="h5" component="h1" className={classes.title}>
            Desculpe
          </Typography>
          <Typography gutterBottom variant="body1" component="p" className={classes.description}>
            Ainda não foram publicadas todas as aulas do curso.
          </Typography>
        </Paper>
      </div>
    </ContentWrapper>
  );
}
export default NoContent